// pc
function pcGSAPAnimateInit() {
  // 关闭弹窗视频
  $(".one-video-playDiv-closeBtn").click(function () {
    $(".one-video-playDiv").hide();
    $("#one-video-playDiv-video")[0].pause();
    $(".one-video-playDiv-wrapper").html();
  });
  // kv Begin
  // /*

  // */
  // kv End

  // action Begin
  // /*

  $(".one-active-play").click(function () {
    $(".one-video-playDiv").css("display", "flex");
    var src = $(this).attr("data-one-src");
    $(".one-video-playDiv-wrapper").html(
      '<video src="' +
      src +
      '" id="one-video-playDiv-video" class="one-video-playDiv-video" playsinline="true" webkit-playsinline="true" preload="none" controls="controls"></video>'
    );
    $("#one-video-playDiv-video")[0].play();
  });

  // */
  // action End

  // relaxed Begin
  // /*

  const relaxedanimation = gsap.timeline({ paused: true })
    .fromTo(".one-relaxed-txt", { opacity: 0, }, { opacity: 1 })
    .fromTo(".one-relaxed-txt", { top: "10rem" }, { top: "0rem", duration: 1 }, "<")
    .fromTo(".one-relaxed-img", { top: "22rem" }, { top: "0rem", duration: 1 }, "<");

  const st = ScrollTrigger.create({
    trigger: ".one-relaxed-top",
    start: "bottom 60%", // 元素顶部到视口80%位置 → 播放动画（更符合视觉触发习惯）
    end: "bottom 80%",
    animation: relaxedanimation,
    onStart: () => {
      relaxedanimation.play();
    },
    onEnterBack: (e) => {
      relaxedanimation.reverse(); // 直接重置，跳过反向播放
    }
  });
  // */
  // relaxed End

  // light Begin
  // /*
  ScrollTrigger.create({
    trigger: ".one-light-section",
    start: "40% bottom",
    end: "120% bottom",
    scrub: 0.8,
    animation: gsap.timeline()
      .fromTo(".one-light-title", { opacity: 1 }, { opacity: 0 })
      .fromTo(".one-light-img", { transform: "scale(1.81) translateX(4.5%)" }, { transform: "scale(1) translateX(0%)" }, "<")
      .fromTo(".one-light-txt", { transform: "translateY(6rem)", opacity: 0 }, { transform: "translateY(0rem)", opacity: 1, duration: 0.3 },'<+=0.3s')
  });
  // */
  // light End

  // featherlight Begin
  // /*
  // 获取所有需要动画的元素
  const featherlightshowD = gsap.utils.toArray('.one-featherlight-section .pc-showD');

  // 先创建统一的交错动画（针对所有元素）
  const featherlightshowDAnimation = gsap.from(featherlightshowD, {
    yPercent: 50,
    opacity: 0,
    stagger: 0.1, // 这里才是stagger的正确位置：多个元素之间错开0.1秒
    paused: true // 先暂停动画，由ScrollTrigger控制
  });

  // 为整个元素组创建一个ScrollTrigger（而不是每个元素单独创建）
  ScrollTrigger.create({
    trigger: '.one-featherlight-card', // 用父容器作为触发点，更合理
    start: "top 90%", // 元素顶部到视口90%位置时开始
    end: "20% 15%", // 结束位置
    animation: featherlightshowDAnimation, // 绑定上面创建的交错动画
    toggleActions: 'play none none reverse', // 滚动到触发点播放，回滚时倒放
    // 可选：添加标记，方便调试
    // markers: true 
  });


  // */
  // featherlight End


  // fully Begin
  // /*

  const winH = window.innerHeight;
  const colorH = $(".one-color-section")[0].clientHeight;

  window.ONE.onePin(".one-fully-color",2500 + colorH)
  ScrollTrigger.create({
    trigger: ".one-fully-color-top",
    start: "top top",
    end: `+=2500`,
    scrub: 1,
    animation: gsap.timeline()
      .fromTo(".one-fully-img", { bottom: "-115rem" }, { bottom: "-109rem" })
      .fromTo(".one-fully-txt .one-h1", { opacity: 0, y: "3rem" }, { opacity: 1, y: 0 }, "<")
      .fromTo(".one-fully-txt .one-b2", { opacity: 0, y: "6rem" }, { opacity: 1, y: 0 }, "<")
      .fromTo(".one-fully-txt .one-fully-eyeglassbox", { opacity: 0, y: "6rem" }, { opacity: 1, y: 0 }, "<")
      .fromTo([".one-fully-img2", ".one-fully-img3"], { marginTop: "9.3rem" }, { marginTop: "0rem" }, "<")
      .fromTo(".one-fully-img2", { opacity: 1 }, { opacity: 0, duration: 0.1 }, "<")
      .fromTo(".one-fully-img3", { opacity: 0 }, { opacity: 1, duration: 0.1 }, "<")
      .fromTo(".one-fully-txt", { opacity: 1, y: 0 }, { opacity: 0, y: "-50rem" }, ">0.2s")
      .fromTo(".one-fully-img", { bottom: "-109rem", left: "-52.35rem" ,scale: 1}, { bottom: "-110rem", left: "-31rem",scale: 1.1 ,duration:0.4}, "<")
      .fromTo(".one-fully-section", { backgroundColor: "#ffffff" }, { backgroundColor: "#000000" }, "<")
      .fromTo(".one-fully-shadow", { opacity: 1, }, { opacity: 0 }, "<")
      .fromTo(".one-fully-img1", { opacity: 1, }, { opacity: 0.3 }, "<")
      .fromTo(".one-fully-card1", { yPercent: 50, opacity: 0 }, { yPercent: 0, opacity: 1 }, "<+0.1s")
      .fromTo(".one-fully-card2", { yPercent: 50, opacity: 0 }, { yPercent: 0, opacity: 1 }, "<+0.1s")
      .fromTo(".one-fully-card3", { yPercent: 50, opacity: 0 }, { yPercent: 0, opacity: 1 }, "<+0.1s")
      .fromTo(".one-fully-cardbox", { opacity: 1 }, { opacity: 1, duration: 0.1 }, ">")
  });
  ScrollTrigger.create({
    trigger: ".one-fully-color-top",
    start: "top+=2500 top",
    end: `+=` + winH,
    scrub: true,
    animation: gsap.timeline()
      .fromTo(".one-color-section", { y: 0 }, { y: -winH })
  });
  
  // console.log(`translateY(${colorH < winH ? "0%" : (colorH - winH + "px")})`)
  //   window.addEventListener('resize', ()=>{
  //     colorplist = $(".one-color-p").map((index, e) => {
  //       const name = $(e).find(".one-color-name");
  //       const txt = $(e).find(".one-color-txt");

  //       return {
  //         close: {
  //           width: name[0].offsetWidth + 4 + "px",
  //           height: name[0].clientHeight +4 + "px"
  //         },
  //         open: {
  //           width: txt[0].offsetWidth + "px",
  //           height: txt[0].clientHeight + "px"
  //         }
  //       }
  //     });
  // });
  // let colorplist = $(".one-color-p").map((index, e) => {
  //   const name = $(e).find(".one-color-name");
  //   const txt = $(e).find(".one-color-txt");

  //   return {
  //     close: {
  //       width: (name[0].offsetWidth + 4) + "px",
  //       height: name[0].offsetHeight + "px"
  //     },
  //     open: {
  //       width: txt[0].offsetWidth + "px",
  //       height: txt[0].offsetHeight + "px"
  //     }
  //   }
  // });
  
  // window.addEventListener("resize", () => {
  //   colorplist = $(".one-color-p").map((index, e) => {
  //     const name = $(e).find(".one-color-name");
  //     const txt = $(e).find(".one-color-txt");
  //     return {
  //       close: {
  //         width: (name[0].offsetWidth + 4) + "px",
  //         height: name[0].offsetHeight + "px"
  //       },
  //       open: {
  //         width: txt[0].offsetWidth + "px",
  //         height: txt[0].offsetHeight + "px"
  //       }
  //     }
  //   });
  //   for (let i = 0; i < 4; i++) {
  //     if (colorIndex==i) {
  //       $(".one-color-p").eq(i).css(colorplist[i].open);
  //     }else{
  //       $(".one-color-p").eq(i).css(colorplist[i].close);

  //     }
  //   }
  // });

  let colorIndex = 0;

  // $(".one-color-p").eq(colorIndex).animate(colorplist[colorIndex].open, 300);

  $(".one-color-p").click(function () {
    const index = $(this).index();
    $(".one-color-p").removeClass("active")
    $(".one-color-p").eq(index).addClass("active");


    // $(".one-color-p").eq(colorIndex).css(colorplist[colorIndex].close);
    // $(".one-color-p").eq(index).css(colorplist[index].open);
    colorIndex = index;
  })




  // */
  // fully End

  // color Begin
  // /*
  // const topH = content.clientHeight - window.innerHeight - ((content.clientHeight - swiper.offsetTop - swiper.clientHeight)-(window.innerHeight - 50 - swiper.clientHeight) / 2);

  const topH = colorH - window.innerHeight;
  var colorVideo = $(".one-color-video")[0]
  // console.log(topH)
  console.log(topH);
  
  if (topH > 0) {
    ScrollTrigger.create({
      trigger: '.one-fully-color-top',
      start: `top+=${2500 + winH} top`,
      end: "+=" + topH,
      scrub: 1,
      onEnter: () => {
        colorVideo.currentTime = 0;
        colorVideo.play()
      },
      animation: gsap.timeline()
        .fromTo(".one-color-wrapper", { y: 0 }, { y: -topH })
    });
  }else{
    ScrollTrigger.create({
      trigger: '.one-fully-color-top',
      start: `top+=${2500 + winH} top`,
      end: "+=" + topH,
      scrub: 1,
      onEnter: () => {
        colorVideo.currentTime = 0;
        colorVideo.play()
      }
    });
  }

  // */
  // color End


  // setting Begin
  // /*
  // 获取所有需要动画的元素
  const settingshowD = gsap.utils.toArray('.one-setting-section .pc-showD');

  // 先创建统一的交错动画（针对所有元素）
  const settingshowDAnimation = gsap.from(settingshowD, {
    yPercent: 50,
    opacity: 0,
    stagger: 0.1, // 这里才是stagger的正确位置：多个元素之间错开0.1秒
    paused: true // 先暂停动画，由ScrollTrigger控制
  });

  // 为整个元素组创建一个ScrollTrigger（而不是每个元素单独创建）
  ScrollTrigger.create({
    trigger: '.one-setting-section .pc-showD', // 用父容器作为触发点，更合理
    start: "top 90%", // 元素顶部到视口90%位置时开始
    end: "20% 15%", // 结束位置
    animation: settingshowDAnimation, // 绑定上面创建的交错动画
    toggleActions: 'play none none reverse', // 滚动到触发点播放，回滚时倒放
    // 可选：添加标记，方便调试
    // markers: true 
  });


  // */
  // setting End

  // ai Begin
  // /*
  new Swiper(".one-ai-swiper", {
    slidesPerView: 'auto', // 自动根据滑块宽度计算显示数量（推荐）
    spaceBetween: 12, // 滑块之间的间距（单位：px，避免用%）
    watchSlidesProgress: true, // 优化性能，只处理在视口内的滑块
    touchMoveStopPropagation: true, // 阻止滑动冒泡，避免干扰 ScrollTrigger
    autoplay: {
      delay: 3000, // 设置轮播的延迟时间
      disableOnInteraction: true,
    },
    on: {
      slideChangeTransitionStart: function () {

      },
    },
    navigation: {
      prevEl: '.one-ai-btn.one-btn-left',
      nextEl: '.one-ai-btn.one-btn-right',
      disabledClass: 'one-ai-btn-disabled'

    },
  });
  // */
  // ai End



  // camera Begin
  // /*

    const cameraanimation = gsap.timeline({ paused: true })
    .fromTo(".one-camera-title", { top: '20rem', opacity: 0 }, { top: '3rem', opacity: 1 })
    .fromTo(".one-camera-img", { transform: 'scale(0.9)' }, { transform: 'scale(1)', duration: 1 }, "<0")

    ScrollTrigger.create({
      trigger: ".one-camera-section",
      start: "top 50%",
      // scrub: true,
      // markers:true,
      animation: cameraanimation,
      toggleActions: 'play none none reverse'
    });
  // */
  // camera End

  // control Begin
  // /*
  // var aiFunctionCardRows = $('.one-control-frame')[0];
  // ScrollTrigger.create({
  //     trigger: ".one-control-item.index1.pc-showD",
  //     start: "top 85%",
  //     end: "20% 15%",
  //     animation: gsap.from(aiFunctionCardRows.getElementsByClassName('index1'), {
  //         yPercent: 10,
  //         opacity: 0,
  //         stagger: 0.1
  //     }),
  //     toggleActions: 'play none none reverse'
  // });

  new Swiper('.one-control-swiper', {
    effect: 'fade',
    watchSlidesProgress: true,
    touchMoveStopPropagation: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: true,
    },
    on: {
      slideChange: function () {
        $(".one-control-box .one-control-item").removeClass("active");
        $(".one-control-box .one-control-item").eq(this.activeIndex).addClass("active");
      }
    },
    pagination: {
      type: "custom",
      clickable: true,
      el: ".one-control-box .one-control-itemBox",
      bulletClass: "one-control-item",
    },
  });
  $(".one-control-item").hover(function () {
    $(this).click();
  })
  // */
  // control End

  // capture Begin
  // /*
  var captureVideo = $(".one-capture-video")[0]
  ScrollTrigger.create({
    trigger: ".one-capture-section",
    start: "top top",
    end: "top -20%",
    scrub: true,
    // markers:true,
    onLeaveBack: () => {
      captureVideo.currentTime = 0;
      captureVideo.pause()
    },
    onEnter: () => {
      captureVideo.currentTime = 0;
      captureVideo.play()
    },
    animation: gsap.timeline()
      .fromTo(".one-capture-media", { borderRadius: '1.5rem', width: '69rem', height: '39rem' }, { borderRadius: '0rem', width: '100%' })
  });
  // */
  // capture End

  // best Begin
  // /*
  new Swiper(".one-best-swiper", {
    slidesPerView: 'auto', // 自动根据滑块宽度计算显示数量（推荐）
    spaceBetween: 12, // 滑块之间的间距（单位：px，避免用%）
    watchSlidesProgress: true,
    touchMoveStopPropagation: true,
    autoplay: {
      delay: 3000, // 设置轮播的延迟时间
      disableOnInteraction: true,
    },
    on: {
      slideChangeTransitionStart: function () {

      },
    },
    navigation: {
      prevEl: '.one-best-btn.one-btn-left',
      nextEl: '.one-best-btn.one-btn-right',
      disabledClass: 'one-best-btn-disabled'

    },
  });

  // */
  // best End

  // audio Begin
  // /*
  const audioshowD = gsap.utils.toArray('.one-audio-section .pc-showD');

  // 先创建统一的交错动画（针对所有元素）
  const audioshowDAnimation = gsap.from(audioshowD, {
    yPercent: 50,
    opacity: 0,
    stagger: 0.1, // 这里才是stagger的正确位置：多个元素之间错开0.1秒
    paused: true // 先暂停动画，由ScrollTrigger控制
  });
  audioshowD.forEach((e) => {
    // 为整个元素组创建一个ScrollTrigger（而不是每个元素单独创建）
    ScrollTrigger.create({
      trigger: e, // 用父容器作为触发点，更合理
      start: "top 90%", // 元素顶部到视口90%位置时开始
      end: "20% 15%", // 结束位置
      animation: audioshowDAnimation, // 绑定上面创建的交错动画
      toggleActions: 'play none none reverse', // 滚动到触发点播放，回滚时倒放
      // 可选：添加标记，方便调试
      // markers: true 
    });
  })

  // */
  // audio End



  // power Begin
  // /*

  const powershowD = gsap.utils.toArray('.one-power-section .pc-showD');

  // 先创建统一的交错动画（针对所有元素）
  const powershowDAnimation = gsap.from(powershowD, {
    yPercent: 100,
    opacity: 0,
    stagger: 0.1, // 这里才是stagger的正确位置：多个元素之间错开0.1秒
    paused: true // 先暂停动画，由ScrollTrigger控制
  });
  powershowD.forEach((e) => {
    // 为整个元素组创建一个ScrollTrigger（而不是每个元素单独创建）
    ScrollTrigger.create({
      trigger: e, // 用父容器作为触发点，更合理
      start: "top 90%", // 元素顶部到视口90%位置时开始
      end: "20% 15%", // 结束位置
      animation: powershowDAnimation, // 绑定上面创建的交错动画
      toggleActions: 'play none none reverse', // 滚动到触发点播放，回滚时倒放
      // 可选：添加标记，方便调试
      // markers: true 
    });
  })
  ScrollTrigger.create({
    trigger: ".one-power-shadow",
    start: "top 85%",
    end: "20% 15%",
    scrub: true,
    animation: gsap.timeline()
      .fromTo(".one-power-shadow", { opacity: 0 }, { opacity: 1 })
  });
  // */
  // power End

  // style Begin
  // /*
  const styleanimation = gsap.timeline({ paused: true }).
      fromTo(".one-style-title ", { opacity: 0, yPercent: 50 }, { opacity: 1, yPercent: 0 })
      .fromTo(".one-style-item1", { opacity: 0, yPercent: 50 }, { opacity: 1 , yPercent: 0}, "<0.2s")
      .fromTo(".one-style-item2 ", { opacity: 0, yPercent: 50 }, { opacity: 1 , yPercent: 0}, "<0.2s")
  ScrollTrigger.create({
    trigger: ".one-style-section",
    start: "top 60%",
    // scrub: true,
    // markers:true,
    animation: styleanimation,
    toggleActions: 'play none none reverse'
  });

  // */
  // style End


  // detail Begin
  // /*


  const detailSection = document.querySelector('.one-detail-section');
  const detailshowD = gsap.utils.toArray('.one-detail-section .pc-showD');

  if (detailSection && detailshowD.length > 0) {
    ScrollTrigger.create({
      trigger: detailSection,
      start: "top 20%",
      end: "20% 15%",
      animation: gsap.from(detailshowD, {
        yPercent: 200,
        opacity: 0,
        stagger: 0.1,
        duration: 1
      }),
      toggleActions: 'play none none reverse'
    });
  }
  // */
  // detail End


  // media Begin
  // /*
  new Swiper(".one-media-swiper", {
    slidesPerView: 'auto', // 自动根据滑块宽度计算显示数量（推荐）
    spaceBetween: 12, // 滑块之间的间距（单位：px，避免用%）
    watchSlidesProgress: true,
    touchMoveStopPropagation: true,
    autoplay: {
      delay: 3000, // 设置轮播的延迟时间
      disableOnInteraction: true,
    },
    on: {
      slideChangeTransitionStart: function () {

      },
    },
    navigation: {
      prevEl: '.one-media-btn.one-btn-left',
      nextEl: '.one-media-btn.one-btn-right',
      disabledClass: 'one-media-btn-disabled'

    },
  });
  // */
  // media End

  // users Begin
  // /*
  new Swiper(".one-users-swiper", {
    slidesPerView: 'auto', // 自动根据滑块宽度计算显示数量（推荐）
    spaceBetween: 12, // 滑块之间的间距（单位：px，避免用%）
    watchSlidesProgress: true,
    touchMoveStopPropagation: true,
    autoplay: {
      delay: 3000, // 设置轮播的延迟时间
      disableOnInteraction: true,
    },
    on: {
      slideChangeTransitionStart: function () {

      },
    },
    navigation: {
      prevEl: '.one-users-btn.one-btn-left',
      nextEl: '.one-users-btn.one-btn-right',
      disabledClass: 'one-users-btn-disabled'

    },
  });
  // */
  // users End
}

// $(".one-form-button1").click(function() {
//   const form = $("#one-contact_form1");
//   const formData = {data: {}};
//   if(!form.serializeArray()[0].value) {
//     alert(`${form.data("inputerror")}`)
//     return;
//   }
//   formData.data[form.serializeArray()[0].name] = form.serializeArray()[0].value;

//    $.ajax({
// 		type: "POST",
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     url: form.data("action"),
//     data: JSON.stringify(formData),
//     success: function (t) {
//       $("#one-contact_form1")[0].reset();
//     },
//     error: function () {
//     },
//   });
// })

// $(".one-form-button2").click(function() {
//     const form = $("#one-contact_form2");
//     const formData = {data: {}};
//     if(!form.serializeArray()[0].value) {
//         alert(`${form.data("inputerror")}`)
//         return;
//     }
//     formData.data[form.serializeArray()[0].name] = form.serializeArray()[0].value;

//     $.ajax({
//         type: "POST",
//         headers: {
//             'Content-Type': 'application/json',
//         },
//         url: form.data("action"),
//         data: JSON.stringify(formData),
//         success: function (t) {
//             $("#one-contact_form2")[0].reset();
//         },
//         error: function () {
//         },
//     });
// })

// $(".one-form-button3").click(function() {
//     const form = $("#one-contact_form3");
//     const formData = {data: {}};
//     if(!form.serializeArray()[0].value) {
//         alert(`${form.data("inputerror")}`)
//         return;
//     }
//     formData.data[form.serializeArray()[0].name] = form.serializeArray()[0].value;

//     $.ajax({
//         type: "POST",
//         headers: {
//             'Content-Type': 'application/json',
//         },
//         url: form.data("action"),
//         data: JSON.stringify(formData),
//         success: function (t) {
//             $("#one-contact_form3")[0].reset();
//         },
//         error: function () {
//         },
//     });
// })